import { IkeEnvironment, IkeSystem } from '@ikegps/core-api';
import { IkeConfig } from '../..';
import { IkeLog, IkeLogStreamType, IkeLogType } from '../../../log';
import { LogConfig } from '../log';
import { OfficeBase } from './office.base';

export const OfficeLocal = new IkeConfig(IkeSystem.OFFICE, IkeEnvironment.LOCAL);
const config = OfficeLocal;

config.extend(OfficeBase);
config.set('application.name', 'IkeOffice Local');
config.set('application.version', '9.9.9');
config.set('application.url', 'http://localhost:1337');
config.set('application.id', 'dragon-local');
config.set('application.api', '/parse');
config.set('application.master', 'myMasterKey');

config.set('config.store', 'local');

config.set('auth0.client.id', 'UTXCZFCGFuN4j1OfmI7f5wjqbHPmCL7V');
config.set('auth0.client.secret', 'a very secret secret key');
config.set('auth0.office.backend.client.id', 'bQh8p9iMumlpmC2ASf08iL9ZN4wfZdsy');
config.set('auth0.domain', 'https://login.ikegps.net');
config.set('auth0.tenant.domain', 'https://ikegps-sandbox.us.auth0.com');
config.set('auth0.audience', 'http://localhost:1337/v1/');

config.set('vendor.google.mapsReleaseChannel', 'weekly');

config.set('storage.path', '/files');
config.set('storage.bucket', 'ike-office-staging');
config.set('storage.prefix', 'dragon-beta/files');
config.set('storage.url', config.get('application.url') + '/files');
config.set('storage.private.prefix', 'dragon-beta/files');

config.set('vendor.google.maps', 'AIzaSyA_j7Kpx-R8dPxO29kD6Id0EX724Yj_vZc');

config.set('event.queue.api.url', 'http://localhost:3000/event/ingest');
config.set('event.queue.api.key', 'test');

config.set('database.username', '');
config.set('database.host', 'localhost');
config.set('database.password', '');
config.set('database.database', 'dragon-local');

config.set('elastic.index.name', 'collectionevent_dev');
config.set('elastic.enabled', false);
config.set('elastic.host', 'http://localhost');
config.set('elastic.port', '9200');
config.set('elastic.username', '');
config.set('elastic.password', '');

config.set('aws.region', 'us-east-1');

config.set('som.url', 'http://localhost:1234');
config.set('ike.access.api.url', 'http://localhost:3001');
config.set('ike.access.api.audience', '');
config.set('ike.access.api.performer.id', '');
config.set('ike.access.api.performer.organization', '');
config.set('ike.access.license.cache.enabled', true);
config.set('ike.access.license.cache.ttl.seconds', 300); // 5 minutes for testing

LogConfig.register(OfficeLocal, IkeLogType.SERVER, IkeLog.TRACE, IkeLogStreamType.CONSOLE);
LogConfig.register(OfficeLocal, IkeLogType.CLI, IkeLog.TRACE, IkeLogStreamType.CONSOLE);
LogConfig.register(OfficeLocal, IkeLogType.BOT, IkeLog.TRACE, IkeLogStreamType.CONSOLE);
LogConfig.register(OfficeLocal, IkeLogType.FUNCTION, IkeLog.TRACE, IkeLogStreamType.CONSOLE);
LogConfig.register(OfficeLocal, IkeLogType.CLIENT, IkeLog.FATAL, IkeLogStreamType.CONSOLE);
